import "./index.css";
import React, { useEffect, useState } from "react";
import { Sidebar } from "../../components/sidebar";
import { Wrapper } from "../../components/wrapper";
import { useNavigate } from "react-router-dom";
import { getDocs } from "../../services/car";
import axios from "axios";
import config from "../../services/index";
import { Spinner } from "../../components/spinner";
import SearchIcon from "@mui/icons-material/Search";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddIcon from "@mui/icons-material/Add";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import { findAllCars } from "../../services/car";
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ShowChartIcon from "@mui/icons-material/ShowChart";

export function Dashboard() {
  let navigate = useNavigate();
  const handleClick = () => {
    navigate("/dashboard/newfile");
  };

  return (
    <>
      <div className="flex w-full min-h-screen bg-sidebar-bg">
        <Sidebar />
        <div className="flex-1 w-full p-4">
          <Wrapper>
            <View />
          </Wrapper>
        </div>
      </div>
      <button
        onClick={handleClick}
        className="fixed bottom-6 right-6 z-30 w-14 h-14 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-full shadow-xl flex items-center justify-center transition-all duration-200 hover:scale-110 hover:shadow-2xl group"
        aria-label="Crear nuevo registro"
      >
        <AddIcon className="group-hover:rotate-90 transition-transform duration-200" />
      </button>
    </>
  );
}

const StatCard = ({ title, value, subtitle, icon: Icon, badge, trend }) => {
  return (
    <div className="bg-sidebar-bg rounded-xl p-6 border border-sidebar-accent hover:border-blue-500/30 transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <p className="text-gray-500 text-xs font-medium uppercase tracking-wider">
              {title}
            </p>
          </div>
          <h3 className="text-3xl font-bold text-white mb-1">{value}</h3>
          {subtitle && <p className="text-sm text-gray-400">{subtitle}</p>}
        </div>

        <div className="flex flex-col items-end gap-4">
          <div>
            {badge && (
              <span
                className={`px-2 py-0.5 text-xs font-semibold rounded-full ${
                  badge.type === "success"
                    ? "bg-green-500/10 text-green-400 border border-green-500/20"
                    : badge.type === "warning"
                    ? "bg-yellow-500/10 text-yellow-400 border border-yellow-500/20"
                    : "bg-blue-500/10 text-blue-400 border border-blue-500/20"
                }`}
              >
                {badge.text}
              </span>
            )}
          </div>

          <div className="ml-4 p-3 bg-blue-500/5 rounded-xl border border-blue-500/10">
            <Icon className="text-blue-400" sx={{ fontSize: 24 }} />
          </div>
        </div>
      </div>

      {trend && (
        <div className="pt-3 border-t border-sidebar-accent flex items-center justify-between">
          <span className="text-xs text-gray-500">{trend.label}</span>
          <div
            className={`flex items-center gap-1 text-xs font-medium ${
              trend.isPositive ? "text-green-400" : "text-red-400"
            }`}
          >
            <TrendingUpIcon
              sx={{ fontSize: 14 }}
              className={!trend.isPositive ? "rotate-180" : ""}
            />
            {trend.value}
          </div>
        </div>
      )}
    </div>
  );
};

const SearchCard = ({
  title,
  placeholder,
  onSearch,
  result,
  icon: Icon,
  type,
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const validateInput = (input) => {
    if (!input.trim()) {
      setError("Este campo es requerido");
      return false;
    }

    if (type === "license") {
      const patternNew = /^[A-Z]{4}\d{2}$/;
      const patternOld = /^[A-Z]{2}\d{4}$/;
      if (
        !patternNew.test(input.toUpperCase()) &&
        !patternOld.test(input.toUpperCase())
      ) {
        setError("Formato de patente inválido (ej: ABCD12 o AB1234)");
        return false;
      }
    }

    if (type === "rut") {
      const rutPattern = /^\d{7,8}-[\dkK]$/;
      if (!rutPattern.test(input)) {
        setError("Formato de RUT inválido (ej: 12345678-9)");
        return false;
      }
    }

    setError("");
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateInput(value)) {
      setSuccess(true);
      onSearch(value.trim());
      setTimeout(() => setSuccess(false), 2000);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    if (error) setError("");
  };

  return (
    <div className="bg-sidebar-bg rounded-xl p-6 border border-sidebar-accent hover:border-blue-500/50 transition-all duration-300">
      <div className="flex items-center gap-3 mb-5">
        <div className="p-2 bg-blue-500/10 rounded-lg">
          <Icon className="text-blue-400" sx={{ fontSize: 24 }} />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <p className="text-xs text-gray-500">Ingresa los datos para buscar</p>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="relative">
          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            className={`w-full px-4 py-3 bg-black border ${
              error
                ? "border-red-500 focus:ring-red-500"
                : success
                ? "border-green-500 focus:ring-green-500"
                : "border-sidebar-accent focus:ring-blue-500"
            } rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:border-transparent transition-all`}
          />
          {success && (
            <CheckCircleIcon
              className="absolute right-3 top-3 text-green-400"
              sx={{ fontSize: 20 }}
            />
          )}
          {error && (
            <ErrorIcon
              className="absolute right-3 top-3 text-red-400"
              sx={{ fontSize: 20 }}
            />
          )}
        </div>
        {error && (
          <div className="flex items-center gap-2 text-red-400 text-xs bg-red-500/10 px-3 py-2 rounded-lg">
            <ErrorIcon sx={{ fontSize: 14 }} />
            <span>{error}</span>
          </div>
        )}
        <button
          type="submit"
          className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/20 flex items-center justify-center gap-2 group"
        >
          <SearchIcon
            className="group-hover:scale-110 transition-transform"
            sx={{ fontSize: 18 }}
          />
          Buscar
        </button>
      </form>
      {result && !error && (
        <div className="mt-4 flex items-center gap-2 text-sm text-gray-400 bg-gray-900/50 px-4 py-3 rounded-lg border border-sidebar-accent">
          <InfoIcon sx={{ fontSize: 16 }} className="text-blue-400" />
          <span>
            Búsqueda: <span className="text-white font-medium">{result}</span>
          </span>
        </div>
      )}
    </div>
  );
};

const ResultCard = ({ document }) => {
  if (!document) {
    return (
      <div className="bg-sidebar-bg/60 rounded-xl border border-dashed border-sidebar-accent p-12 text-center">
        <div className="flex flex-col items-center gap-4">
          <div className="p-4 bg-gray-700/30 rounded-full">
            <SearchIcon className="text-gray-500" sx={{ fontSize: 48 }} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-400 mb-2">
              Sin resultados
            </h3>
            <p className="text-sm text-gray-500">
              Realiza una búsqueda para ver los detalles del registro
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-sidebar-bg rounded-xl border border-sidebar-accent overflow-hidden">
      <div className="px-6 py-4 border-b border-sidebar-accent flex items-center justify-between bg-sidebar-accent/30">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-500/10 rounded-lg border border-green-500/20">
            <CheckCircleIcon className="text-green-400" sx={{ fontSize: 20 }} />
          </div>
          <div>
            <h3 className="text-base font-semibold text-white">
              Registro Encontrado
            </h3>
            <p className="text-xs text-gray-500 mt-0.5">
              Información del vehículo
            </p>
          </div>
        </div>
        <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-500/10 text-green-400 border border-green-500/20">
          Activo
        </span>
      </div>

      <div className="p-6">
        <div className="mb-6 pb-4 border-b border-sidebar-accent">
          <p className="text-xs text-gray-500 mb-1">ID de Documento</p>
          <p className="text-sm font-mono text-white bg-black/30 px-3 py-2 rounded-lg inline-block">
            {document._id}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <DetailField
            icon={PersonIcon}
            label="Cliente"
            value={document.customer_name}
            badge="Propietario"
          />
          <DetailField
            icon={BadgeIcon}
            label="RUT"
            value={document.customer_id}
          />
          <DetailField
            icon={DirectionsCarIcon}
            label="Marca"
            value={document.brand}
            badge="Vehículo"
          />
          <DetailField
            icon={DirectionsCarIcon}
            label="Modelo"
            value={document.model}
          />
          <DetailField
            icon={DirectionsCarIcon}
            label="Patente"
            value={document.license}
            highlight
          />
          <DetailField
            icon={DescriptionIcon}
            label="Kilometraje"
            value={`${document.kms} km`}
          />
          {document.phone && (
            <DetailField
              icon={PhoneIcon}
              label="Teléfono"
              value={document.phone}
            />
          )}
          {document.date && (
            <DetailField
              icon={CalendarMonthIcon}
              label="Fecha de Registro"
              value={document.date}
            />
          )}
        </div>

        <div className="mt-6 pt-6 border-t border-sidebar-accent flex gap-3">
          <button
            onClick={() =>
              (window.location.href = `/dashboard/newfile?${document._id}`)
            }
            className="flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-all flex items-center justify-center gap-2"
          >
            <DescriptionIcon sx={{ fontSize: 18 }} />
            Ver Detalles
          </button>
          <button className="px-4 py-2.5 bg-sidebar-accent hover:bg-sidebar-hover text-gray-400 hover:text-white text-sm font-medium rounded-lg transition-all flex items-center justify-center gap-2 border border-sidebar-accent">
            <DirectionsCarIcon sx={{ fontSize: 18 }} />
            Historial
          </button>
        </div>
      </div>
    </div>
  );
};

const NotFoundCard = ({ notFound, onCreateNew }) => {
  if (!notFound) return null;

  return (
    <div className="bg-sidebar-bg rounded-xl border border-orange-500/30 overflow-hidden">
      <div className="px-6 py-4 border-b border-orange-500/30 flex items-center justify-between bg-orange-500/10">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-orange-500/20 rounded-lg border border-orange-500/30">
            <ErrorIcon className="text-orange-400" sx={{ fontSize: 20 }} />
          </div>
          <div>
            <h3 className="text-base font-semibold text-white">
              Registro No Encontrado
            </h3>
            <p className="text-xs text-gray-400 mt-0.5">
              {notFound.message}
            </p>
          </div>
        </div>
        <span className="px-3 py-1 text-xs font-semibold rounded-full bg-orange-500/20 text-orange-400 border border-orange-500/30">
          Sin resultados
        </span>
      </div>

      <div className="p-6">
        <div className="mb-6 p-4 bg-orange-500/5 border border-orange-500/20 rounded-lg">
          <div className="flex items-start gap-3">
            <InfoIcon className="text-orange-400 flex-shrink-0 mt-0.5" sx={{ fontSize: 20 }} />
            <div>
              <p className="text-sm text-gray-300 mb-2">
                No se encontró ningún registro {notFound.type === 'license' ? 'con esta patente' : 'para este cliente'}.
              </p>
              <p className="text-xs text-gray-400">
                {notFound.type === 'license' 
                  ? `Patente buscada: ${notFound.value}`
                  : `RUT buscado: ${notFound.value}`
                }
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <p className="text-sm text-gray-400 text-center">
            ¿Deseas agregar un nuevo registro?
          </p>
          
          <button
            onClick={onCreateNew}
            className="w-full px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/30 flex items-center justify-center gap-3 text-base"
          >
            <AddIcon sx={{ fontSize: 24 }} />
            Crear Nuevo Registro
          </button>

          <p className="text-xs text-gray-500 text-center">
            Serás redirigido al formulario de nuevo registro
          </p>
        </div>
      </div>
    </div>
  );
};

const DetailField = ({ icon: Icon, label, value, badge, highlight }) => {
  return (
    <div
      className={`p-4 rounded-lg border transition-all ${
        highlight
          ? "bg-blue-500/5 border-blue-500/20"
          : "bg-sidebar-accent/30 border-sidebar-accent"
      }`}
    >
      <div className="flex items-center gap-2 mb-2">
        <Icon className="text-gray-500" sx={{ fontSize: 16 }} />
        <span className="text-xs text-gray-500 uppercase tracking-wider font-medium">
          {label}
        </span>
        {badge && (
          <span className="ml-auto px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-500/10 text-blue-400 border border-blue-500/20">
            {badge}
          </span>
        )}
      </div>
      <p
        className={`text-base font-semibold ${
          highlight ? "text-blue-400" : "text-white"
        } truncate`}
      >
        {value || "-"}
      </p>
    </div>
  );
};

const UnifiedSearchCard = ({ onSearchLicense, onSearchRut, searchResults }) => {
  const [activeTab, setActiveTab] = useState("license");
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const validateInput = (input, type) => {
    if (!input.trim()) {
      setError("Este campo es requerido");
      return false;
    }

    if (type === "license") {
      const patternNew = /^[A-Z]{4}\d{2}$/;
      const patternOld = /^[A-Z]{2}\d{4}$/;
      if (
        !patternNew.test(input.toUpperCase()) &&
        !patternOld.test(input.toUpperCase())
      ) {
        setError("Formato de patente inválido (ej: ABCD12 o AB1234)");
        return false;
      }
    }

    if (type === "rut") {
      const rutPattern = /^\d{7,8}-[\dkK]$/;
      if (!rutPattern.test(input)) {
        setError("Formato de RUT inválido (ej: 12345678-9)");
        return false;
      }
    }

    setError("");
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateInput(value, activeTab)) {
      setSuccess(true);
      if (activeTab === "license") {
        onSearchLicense(value.trim());
      } else {
        onSearchRut(value.trim());
      }
      setTimeout(() => setSuccess(false), 2000);
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    if (error) setError("");
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setValue("");
    setError("");
    setSuccess(false);
  };

  const currentResult =
    activeTab === "license" ? searchResults.license : searchResults.rut;
  const currentIcon = activeTab === "license" ? DirectionsCarIcon : PersonIcon;
  const CurrentIcon = currentIcon;

  return (
    <div className="bg-sidebar-bg rounded-xl p-6 border border-sidebar-accent hover:border-blue-500/50 transition-all duration-300">
      <div className="flex items-center gap-3 mb-5">
        <div className="p-2 bg-blue-500/10 rounded-lg">
          <SearchIcon className="text-blue-400" sx={{ fontSize: 24 }} />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-white">
            Búsqueda de Registros
          </h3>
          <p className="text-xs text-gray-500">
            Busca por patente o RUT del cliente
          </p>
        </div>
      </div>

      <div className="flex gap-2 mb-4 p-1 bg-black rounded-lg">
        <button
          type="button"
          onClick={() => handleTabChange("license")}
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
            activeTab === "license"
              ? "bg-blue-600 text-white shadow-lg"
              : "text-gray-400 hover:text-white hover:bg-sidebar-accent"
          }`}
        >
          <DirectionsCarIcon sx={{ fontSize: 18 }} />
          Patente
        </button>
        <button
          type="button"
          onClick={() => handleTabChange("rut")}
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
            activeTab === "rut"
              ? "bg-blue-600 text-white shadow-lg"
              : "text-gray-400 hover:text-white hover:bg-sidebar-accent"
          }`}
        >
          <PersonIcon sx={{ fontSize: 18 }} />
          RUT
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="relative">
          <div className="absolute left-3 top-3 pointer-events-none">
            <CurrentIcon className="text-gray-500" sx={{ fontSize: 20 }} />
          </div>
          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder={
              activeTab === "license" ? "Ej: ABCD12 o AB1234" : "Ej: 12345678-9"
            }
            className={`w-full pl-11 pr-4 py-3 bg-black border ${
              error
                ? "border-red-500 focus:ring-red-500"
                : success
                ? "border-green-500 focus:ring-green-500"
                : "border-sidebar-accent focus:ring-blue-500"
            } rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:border-transparent transition-all`}
          />
          {success && (
            <CheckCircleIcon
              className="absolute right-3 top-3 text-green-400"
              sx={{ fontSize: 20 }}
            />
          )}
          {error && (
            <ErrorIcon
              className="absolute right-3 top-3 text-red-400"
              sx={{ fontSize: 20 }}
            />
          )}
        </div>

        {error && (
          <div className="flex items-center gap-2 text-red-400 text-xs bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
            <ErrorIcon sx={{ fontSize: 14 }} />
            <span>{error}</span>
          </div>
        )}

        <button
          type="submit"
          className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/20 flex items-center justify-center gap-2 group"
        >
          <SearchIcon
            className="group-hover:scale-110 transition-transform"
            sx={{ fontSize: 18 }}
          />
          Buscar {activeTab === "license" ? "Patente" : "RUT"}
        </button>
      </form>

      {currentResult && !error && (
        <div className="mt-4 flex items-center gap-2 text-sm text-gray-400 bg-gray-900/50 px-4 py-3 rounded-lg border border-sidebar-accent">
          <InfoIcon sx={{ fontSize: 16 }} className="text-blue-400" />
          <span>
            Última búsqueda:{" "}
            <span className="text-white font-medium">{currentResult}</span>
          </span>
        </div>
      )}
    </div>
  );
};

const COLORS = [
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
  "#f59e0b",
  "#10b981",
  "#06b6d4",
  "#6366f1",
  "#f43f5e",
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-sidebar-bg border border-sidebar-accent rounded-lg p-3 shadow-xl">
        <p className="text-white font-semibold mb-1">{label}</p>
        <p className="text-blue-400 text-sm">
          {payload[0].name}: {payload[0].value}
        </p>
      </div>
    );
  }
  return null;
};

const MetricsCard = ({ title, icon: Icon, children }) => {
  return (
    <div className="bg-sidebar-bg rounded-xl p-6 border border-sidebar-accent">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-blue-500/10 rounded-lg">
          <Icon className="text-blue-400" sx={{ fontSize: 24 }} />
        </div>
        <h3 className="text-lg font-semibold text-white">{title}</h3>
      </div>
      {children}
    </div>
  );
};

export const View = () => {
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState(null);
  const [stats, setStats] = useState({
    total: "-",
    monthly: "-",
  });
  const [searchResults, setSearchResults] = useState({
    license: null,
    rut: null,
  });
  const [notFound, setNotFound] = useState(null);
  const navigate = useNavigate();
  const [metrics, setMetrics] = useState({
    byBrand: [],
    byYear: [],
    byMotorType: [],
    servicesTimeline: [],
  });
  const [period, setPeriod] = useState('year');
  const [vehicleMetrics, setVehicleMetrics] = useState(null);
  const [brandStats, setBrandStats] = useState(null);

  useEffect(() => {
    getDocs()
      .then((response) => {
        setStats({
          total: response.total,
          monthly: response.monthly,
        });
      })
      .catch((err) => console.log(err));

    findAllCars()
      .then((data) => {
        processMetrics(data);
      })
      .catch((err) => console.error(err));

    fetchVehicleMetrics(period);
    fetchBrandStats();
  }, []);

  useEffect(() => {
    fetchVehicleMetrics(period);
  }, [period]);

  const fetchVehicleMetrics = async (selectedPeriod) => {
    try {
      const { data } = await axios.get(
        `${config.url}/admin/metrics/vehicles?period=${selectedPeriod}`
      );
      if (data.success) {
        setVehicleMetrics(data);
      }
    } catch (err) {
      console.error('Error fetching vehicle metrics:', err);
    }
  };

  const fetchBrandStats = async () => {
    try {
      const { data } = await axios.get(`${config.url}/brands/stats`);
      if (data.success) {
        setBrandStats(data);
      }
    } catch (err) {
      console.error('Error fetching brand stats:', err);
    }
  };

  const processMetrics = (cars) => {
    const brandCount = {};
    cars.forEach((car) => {
      const brand = car.brand?.toLowerCase() || "sin marca";
      brandCount[brand] = (brandCount[brand] || 0) + 1;
    });
    const byBrand = Object.entries(brandCount)
      .map(([name, value]) => ({
        name: name.charAt(0).toUpperCase() + name.slice(1),
        value,
      }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 8);

    const yearCount = {};
    cars.forEach((car) => {
      const year = car.year || "N/A";
      if (year !== "N/A") {
        yearCount[year] = (yearCount[year] || 0) + 1;
      }
    });
    const byYear = Object.entries(yearCount)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => a.name.localeCompare(b.name));

    const motorCount = {};
    cars.forEach((car) => {
      const motorType = car.motor_type || "Sin especificar";
      motorCount[motorType] = (motorCount[motorType] || 0) + 1;
    });
    const byMotorType = Object.entries(motorCount).map(([name, value]) => ({
      name,
      value,
    }));

    const servicesCount = {};
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthKey = date.toLocaleDateString("es-ES", {
        month: "short",
        year: "numeric",
      });
      servicesCount[monthKey] = 0;
    }

    cars.forEach((car) => {
      if (car.services && Array.isArray(car.services)) {
        car.services.forEach((service) => {
          if (service.date) {
            try {
              const [day, month, year] = service.date.split("/");
              const serviceDate = new Date(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day)
              );
              const monthKey = serviceDate.toLocaleDateString("es-ES", {
                month: "short",
                year: "numeric",
              });
              if (servicesCount[monthKey] !== undefined) {
                servicesCount[monthKey]++;
              }
            } catch (e) {
              console.log("Error parsing date:", service.date);
            }
          }
        });
      }
    });

    const servicesTimeline = Object.entries(servicesCount).map(
      ([name, servicios]) => ({
        name,
        servicios,
      })
    );

    setMetrics({
      byBrand,
      byYear,
      byMotorType,
      servicesTimeline,
    });
  };

  const handleSearchLicense = async (value) => {
    try {
      setLoading(true);
      setNotFound(null);
      const { data } = await axios.post(
        `${config.url}/car/license`,
        { license: value.toUpperCase(), customer_id: null },
        { headers: { "Content-Type": "application/json" } }
      );
      setDocument(data);
      setSearchResults({ ...searchResults, license: value });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setDocument(null);
      setNotFound({
        type: 'license',
        value: value.toUpperCase(),
        message: `No se encontró ningún registro con la patente "${value.toUpperCase()}"`
      });
      console.log(err);
    }
  };

  const handleSearchRut = async (value) => {
    try {
      setLoading(true);
      setNotFound(null);
      const { data } = await axios.post(
        `${config.url}/car/customer_id`,
        { customer_id: value, license: null },
        { headers: { "Content-Type": "application/json" } }
      );
      setDocument(data);
      setSearchResults({ ...searchResults, rut: value });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setDocument(null);
      setNotFound({
        type: 'rut',
        value: value,
        message: `No se encontró ningún cliente con el RUT "${value}"`
      });
      console.log(err);
    }
  };

  const handleCreateNew = () => {
    navigate('/dashboard/newfile');
  };

  return (
    <>
      {loading && <Spinner />}
      <div className="w-full max-w-7xl mx-auto px-4 lg:px-6 py-8">
        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-500/10 rounded-lg">
                <DashboardIcon className="text-blue-400" sx={{ fontSize: 28 }} />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-white">
                  Panel de Control
                </h1>
                <p className="text-gray-400 text-sm mt-1">
                  Resumen de actividad y métricas principales
                </p>
              </div>
            </div>
            
            <div className="flex gap-2 bg-black rounded-lg p-1 border border-sidebar-accent">
              {['day', 'week', 'month', 'year'].map((p) => (
                <button
                  key={p}
                  onClick={() => setPeriod(p)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${
                    period === p
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-400 hover:text-white hover:bg-sidebar-accent'
                  }`}
                >
                  {p === 'day' ? 'Día' : p === 'week' ? 'Semana' : p === 'month' ? 'Mes' : 'Año'}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <StatCard
            title="Total Vehículos"
            value={vehicleMetrics?.data?.summary?.totalVehicles?.toLocaleString('es-CL') || stats.total}
            subtitle={`Registros en ${period === 'day' ? 'el día' : period === 'week' ? 'la semana' : period === 'month' ? 'el mes' : 'el año'}`}
            icon={DirectionsCarIcon}
            badge={{ text: period === 'year' ? 'Anual' : period === 'month' ? 'Mensual' : period === 'week' ? 'Semanal' : 'Diario', type: "info" }}
          />
          <StatCard
            title="Kilometraje Promedio"
            value={vehicleMetrics?.data?.summary?.avgKms ? `${Math.round(vehicleMetrics.data.summary.avgKms).toLocaleString('es-CL')} km` : '--'}
            subtitle="Promedio del período"
            icon={TrendingUpIcon}
            badge={{ text: "Promedio", type: "success" }}
          />
          <StatCard
            title="Kilometraje Máximo"
            value={vehicleMetrics?.data?.summary?.maxKms ? `${vehicleMetrics.data.summary.maxKms.toLocaleString('es-CL')} km` : '--'}
            subtitle="Mayor registro"
            icon={ShowChartIcon}
            badge={{ text: "Máximo", type: "warning" }}
          />
          <StatCard
            title="Kilometraje Mínimo"
            value={vehicleMetrics?.data?.summary?.minKms ? `${vehicleMetrics.data.summary.minKms.toLocaleString('es-CL')} km` : '--'}
            subtitle="Menor registro"
            icon={InfoIcon}
            badge={{ text: "Mínimo", type: "info" }}
          />
        </div>

        <div className="mb-8">
          <UnifiedSearchCard
            onSearchLicense={handleSearchLicense}
            onSearchRut={handleSearchRut}
            searchResults={searchResults}
          />
        </div>

        {notFound ? (
          <NotFoundCard notFound={notFound} onCreateNew={handleCreateNew} />
        ) : (
          <ResultCard document={document} />
        )}

        <div className="mt-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 bg-purple-500/10 rounded-lg">
              <AssessmentIcon
                className="text-purple-400"
                sx={{ fontSize: 28 }}
              />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-white">
                Métricas y Análisis
              </h2>
              <p className="text-gray-400 text-sm mt-1">
                Estadísticas segmentadas de vehículos
              </p>
            </div>
          </div>

          {vehicleMetrics?.data?.vehiclesByPeriod && vehicleMetrics.data.vehiclesByPeriod.length > 0 && (
            <div className="mb-6">
              <MetricsCard 
                title={`Vehículos Registrados - ${period === 'year' ? 'Por Mes' : period === 'month' ? 'Por Día' : period === 'week' ? 'Por Día' : 'Por Hora'}`} 
                icon={TrendingUpIcon}
              >
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={vehicleMetrics.data.vehiclesByPeriod}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                    <XAxis
                      dataKey="period"
                      stroke="#9ca3af"
                      tick={{ fill: "#9ca3af", fontSize: 11 }}
                      angle={-45}
                      textAnchor="end"
                      height={80}
                    />
                    <YAxis
                      stroke="#9ca3af"
                      tick={{ fill: "#9ca3af", fontSize: 12 }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="count" fill="#10b981" radius={[8, 8, 0, 0]} name="Vehículos" />
                  </BarChart>
                </ResponsiveContainer>
                <div className="mt-4 pt-4 border-t border-sidebar-accent">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-400">Período:</span>
                    <span className="text-white font-semibold">
                      {vehicleMetrics.startDate && new Date(vehicleMetrics.startDate).toLocaleDateString('es-CL')} - {vehicleMetrics.endDate && new Date(vehicleMetrics.endDate).toLocaleDateString('es-CL')}
                    </span>
                  </div>
                </div>
              </MetricsCard>
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <MetricsCard title="Vehículos por Marca" icon={DirectionsCarIcon}>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={metrics.byBrand}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="name"
                    stroke="#9ca3af"
                    tick={{ fill: "#9ca3af", fontSize: 12 }}
                  />
                  <YAxis
                    stroke="#9ca3af"
                    tick={{ fill: "#9ca3af", fontSize: 12 }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Bar dataKey="value" fill="#3b82f6" radius={[8, 8, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </MetricsCard>

            <MetricsCard title="Distribución por Tipo de Motor" icon={InfoIcon}>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={metrics.byMotorType}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percent }) =>
                      `${name}: ${(percent * 100).toFixed(0)}%`
                    }
                    outerRadius={100}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {metrics.byMotorType.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                </PieChart>
              </ResponsiveContainer>
            </MetricsCard>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <MetricsCard title="Vehículos por Año" icon={CalendarMonthIcon}>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={metrics.byYear}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="name"
                    stroke="#9ca3af"
                    tick={{ fill: "#9ca3af", fontSize: 12 }}
                  />
                  <YAxis
                    stroke="#9ca3af"
                    tick={{ fill: "#9ca3af", fontSize: 12 }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="#8b5cf6"
                    strokeWidth={3}
                    dot={{ fill: "#8b5cf6", r: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </MetricsCard>

            <MetricsCard
              title="Servicios Realizados (6 meses)"
              icon={ShowChartIcon}
            >
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={metrics.servicesTimeline}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                  <XAxis
                    dataKey="name"
                    stroke="#9ca3af"
                    tick={{ fill: "#9ca3af", fontSize: 12 }}
                  />
                  <YAxis
                    stroke="#9ca3af"
                    tick={{ fill: "#9ca3af", fontSize: 12 }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Bar
                    dataKey="servicios"
                    fill="#10b981"
                    radius={[8, 8, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </MetricsCard>
          </div>
        </div>
      </div>
    </>
  );
};
